import fetch from './fetch';

const buildFormData = data => {
  const formData = new FormData();
  Object.entries(data).forEach(([k, v]) => {
    formData.append(k, v);
  });
  return formData;
};

// common
export function getDict(params) {
  return fetch('/bms/sys/dict-item/list', {
    data: params,
  });
}

// export function getParamsDict(paramType = 1) {
//   return fetch(`/bms/sys/param/map/${paramType}`)
// }

export function getWxTicket(params) {
  return fetch('/uaa/wechat/signature', {
    data: params,
  })
}

export function login(params) {
  return fetch('/uaa/wechat/login', {
    data: params,
    withoutToken: true
  })
}

export function getUserInfo() {
  return fetch('/bms/sys/user/userinfo');
}

export function queryUserList(params) {
  return fetch('/bms/sys/user/list', {
    data: params,
  });
}

export function updateUserInfo(params) {
  return fetch('/bms/sys/user/modify', {
    method: 'POST',
    data: params
  });
}

export function getOneMap(data) {
  return fetch('/bms/biz/wechat/shop/one-rental-map', {
    data,
    withoutToken: true
  });
}

export function getMarketStall(data) {
  return fetch(`/bms/biz/wechat/shop/one-rental-map/stall-detail/${data.id}`, {
    withoutToken:true
  });
}

// 获取店铺详情 /bms/biz/wechat/shop/find/
export function getMarketShop(data) {
  return fetch(`/bms/biz/market/shop/find/${data.id}`, {
    params: data
  });
}


// 获取店铺相关联系人
export function getMarketShopContacts(data) {
  return fetch('/bms/biz/wechat/shop/query/contacts', {
    params: data
  });
}


export function applySettleInValid(data) {
  return fetch('/bms/biz/wechat/shop/apply-settle-in/valid', {
    data
  });
}

export function applySettleIn(params) {
  return fetch('/bms/biz/wechat/shop/apply-settle-in', {
    method: 'POST',
    data: params
  });
}

export function applySettleModify(params) {
  return fetch('/bms/biz/wechat/shop/apply-modify', {
    method: 'POST',
    data: params
  });
}

//创建邀请
export function createInvite(data) {
  return fetch('/bms/biz/wechat/shop/invite/create', {
    data
  });
}

//查询邀请
export function getInviteDetail(data) {
  return fetch(`/bms/biz/wechat/shop/invite/${data.inviteId}`, {});
}

//邀请员工
export function inviteStaff(data) {
  return fetch(`/bms/biz/wechat/shop/invite/staff/by/${data.inviteId}`, {});
}

//租赁报名
export function submitRentSignUp(params) {
  return fetch('/bms/biz/wechat/shop/submit-rent-sign-up', {
    method: 'POST',
    data: params,
    withoutToken:true
  });
}


//租金页面初始化信息
export function getMarketShopRentInfo(data) {
  return fetch(`/bms/biz/wechat/shop/rent-info/find/${data.id}`, {});
}

//续租申请
export function applyMarketShopRenewal(params) {
  return fetch('/bms/biz/shop-rent/renewal-apply', {
    method: 'POST',
    data: params
  });
}


//支付准备
export function initPay(params) {
  return fetch('/bms/biz/pay/init-pay', {
    data: params
  });
}

// 浙江农商预下单（保证金、物业费等）
export function zjnsInitPay(params) {
  return fetch('/bms/zjns/init-pay', {
    data: params
  });
}

/** 收银台链接：14293300 需替换为 14293330 */
export function normalizeZjnsCodeUrl(codeUrl) {
  if (!codeUrl) return codeUrl;
  return codeUrl.replace(/14293300/g, '14293330');
}

// 物业费缴纳申请
export function createPropertyApply(params) {
  return fetch('/bms/biz/shop-property/property-apply', {
    method: 'POST',
    data: params
  });
}

export function getPropertyApplyPage(params) {
  return fetch('/bms/biz/shop-property/property-apply/page', {
    data: params
  });
}

export function getRenewalApplyPage(params) {
  return fetch('/bms/biz/shop-rent/renewal-apply/page', {
    data: params
  });
}

/** 可选租期列表（物业费申请用，按店铺查铺面租期） */
export function getStallRentTermListByShop(params) {
  return fetch('/bms/biz/stall-rent-term/list-by-shop', {
    data: params
  });
}

/** @deprecated 请改用 getStallRentTermListByShop */
export function getRenewalApplyList(params) {
  return getStallRentTermListByShop(params);
}

//支付异常处置
export function handleExceptionPay(params) {
  return fetch('/bms/biz/wechat/paid-error-handle', {
    method: 'POST',
    data: params
  });
}


//其它费用
export function getMarketShopFeeInfo(data) {
  return fetch(`/bms/biz/wechat/shop/fee-info/find/${data.id}`, {});
}

//创建电费充值订单
export function createElectricityPreOrder(params) {
  return fetch(`/bms/biz/wechat/shop/electricity-pre-order/create`,{
    data: params
  });
}

//创建水费充值订单
export function createWaterPreOrder(params) {
  return fetch(`/bms/biz/wechat/shop/water-pre-order/create`,{
    data: params
  });
}


//支付订单列表
export function getPaidOrderList(params) {
  return fetch('/bms/biz/wechat/shop/paid-order/list', {
    data: params
  });
}


//通知分页列表
export function getNoticePage(params) {
  return fetch('/bms/sys/notice/wechat/page', {
    data: params
  });
}

//通知详情
export function getNoticeFeedbackDetail(data) {
  return fetch(`/bms/sys/notice/wechat/feedback/find/${data.id}`, {});
}

//通知反馈
export function feedbackNotify(params) {
  return fetch('/bms/sys/notice/feedback', {
    method: 'POST',
    data: params
  });
}


//获取一个铺面同状态的店铺数量
export function getSameShopStatusCnt(params) {
  return fetch('/bms/biz/wechat/shop/same-status/cnt', {
    data: params
  });
}


//获取当前用户所有的店铺
export function getLoginUserShops(params) {
  return fetch('/bms/biz/wechat/shop/user/shops', {
    data: params
  });
}

//切换当前用户店铺
export function changeLoginUserCurrentShop(params) {
  return fetch('/bms/biz/wechat/shop/user/current-shop-id', {
    data: params
  });
}


/*****************************物业维修************************/
export function getRepairOrderPage(params) {
  return fetch('/bms/biz/repair-order/wechat/page', {
    data: params
  });
}


export function saveRepairOrder(params) {
  return fetch('/bms/biz/repair-order/save', {
    method: 'POST',
    data: params
  });
}

export function editRepairOrder(params) {
  return fetch('/bms/biz/repair-order/edit', {
    method: 'POST',
    data: params
  });
}

export function dispatchRepairOrder(params) {
  return fetch('/bms/biz/repair-order/dispatch', {
    method: 'POST',
    data: params
  });
}

export function getRepairOrderDetail(data) {
  return fetch(`/bms/biz/repair-order/find/${data.id}`, {});
}

export function removeRepairOrder(params) {
  return fetch('/bms/biz/repair-order/remove', {
    method: 'POST',
    data: params
  });
}

export function evaRepairOrder(params) {
  return fetch('/bms/biz/repair-order/eva', {
    method: 'POST',
    data: params
  });
}


/*****************************验房维修************************/
export function getPropertyInspectionPage(params) {
  return fetch('/bms/biz/property-inspection/wechat/page', {
    data: params
  });
}

export function getPropertyInspectionDetail(data) {
  return fetch(`/bms/biz/property-inspection/find/${data.id}`, {});
}

export function getPropertyInspectionDetailByCurrentUser(data) {
  return fetch(`/bms/biz/property-inspection/find-by-current-user`, {});
}

export function getPropertyInspectionElectricWaterDetail(data) {
  return fetch(`/bms/biz/property-inspection/find-for-water-electric`, {});
}


export function savePropertyInspection(params) {
  return fetch('/bms/biz/property-inspection/save', {
    method: 'POST',
    data: params
  });
}


export function editPropertyInspection(params) {
  return fetch('/bms/biz/property-inspection/edit', {
    method: 'POST',
    data: params
  });
}

export function editPropertyInspectionMarginInfo(params) {
  return fetch('/bms/biz/property-inspection/margin-info', {
    method: 'POST',
    data: params
  });
}

export function editPropertyInspectionBaseInfo(params) {
  return fetch('/bms/biz/property-inspection/base-info', {
    method: 'POST',
    data: params
  });
}

export function editPropertyInspectionPropertyManageConfirm(params) {
  return fetch('/bms/biz/property-inspection/property-manage-confirm', {
    method: 'POST',
    data: params
  });
}

export function editPropertyInspectionElectricWater(params) {
  return fetch('/bms/biz/property-inspection/electric-water', {
    method: 'POST',
    data: params
  });
}

export function editPropertyInspectionRentConfirm(params) {
  return fetch('/bms/biz/property-inspection/rent-confirm', {
    method: 'POST',
    data: params
  });
}

export function editPropertyInspectionMarketDepartmentFirstConfirm(params) {
  return fetch('/bms/biz/property-inspection/market-department-first-confirm', {
    method: 'POST',
    data: params
  });
}

export function editPropertyInspectionMarketDepartmentSecondConfirm(params) {
  return fetch('/bms/biz/property-inspection/market-department-second-confirm', {
    method: 'POST',
    data: params
  });
}


export function removePropertyInspection(params) {
  return fetch('/bms/biz/property-inspection/remove', {
    method: 'POST',
    data: params
  });
}

/*****************************待支付账单************************/
export function getUnpaidBillPage(params) {
  return fetch('/bms/biz/shop-unpaid-bill/page', {
    data: params
  });
}

export function getUnpaidBillPayRecordList(params) {
  return fetch('/bms/biz/shop-unpaid-bill/pay-record/list', {
    data: params
  });
}

export function getUnpaidBillUnpaidCnt(params) {
  return fetch('/bms/biz/shop-unpaid-bill/unpaid-cnt', {
    data: params
  });
}

// 检查店铺租期是否已过期
export function checkExpiringRent(params) {
  return fetch('/bms/common/check-expiring-rent', {
    data: params
  });
}
